import { render, staticRenderFns } from "./GanttComponent.vue?vue&type=template&id=017a0535&"
import script from "./GanttComponent.vue?vue&type=script&lang=js&"
export * from "./GanttComponent.vue?vue&type=script&lang=js&"
import style0 from "./GanttComponent.vue?vue&type=style&index=0&id=017a0535&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports